<template>
  <div class="text-center">
    <feather-icon icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord"/>
    <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
  </div>
</template>

<script>
  export default {
    name: 'CellRendererActions',

    methods: {
      editRecord() {
        this.$router.push(`/admin/account-data/update?uid=${this.params.data.account}`).catch(() => {
        });
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('adminUserICon.titleDelete'),
          text: ` ${this.$t('adminUserICon.titleDelete')} ` + ` "${this.params.data.name}" `,
          accept: this.deleteRecord,
          acceptText: this.$t('adminUserICon.acceptText'),
          cancelText: this.$t('adminUserICon.cancelText')
        })
      },
      deleteRecord() {
        this.$vs.loading();
        const payload = {
          account:this.params.data.account
        }
        this.$processor.post(`/account-data/delete`,payload).then(() => {
          this.$vs.loading.close();
          this.reloadPage();
          return this.showDeleteSuccess();
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
      showDeleteSuccess() {
        this.$store.commit('UPDATE_USER_SUCCESS', true);
        this.$vs.notify({
          color: 'primary',
          text: this.$t('adminUserICon.textSuccess'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      },
      reloadPage(){
        return new Promise((resolve,reject)=>{
          let conditions = {
            pageSize:10,
            pageNumber:0,
          };
          this.$processor.post('/account-data/get-all',conditions).then((response) =>{
           resolve(response.data);
           this.params.data = response.data;
          })
          .catch((err) =>{
            reject(err);
          })
        })
      }
    }
  }
</script>
